import { render, staticRenderFns } from "./sendFrom.vue?vue&type=template&id=cf045a54&scoped=true"
import script from "./sendFrom.vue?vue&type=script&lang=js"
export * from "./sendFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf045a54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf045a54')) {
      api.createRecord('cf045a54', component.options)
    } else {
      api.reload('cf045a54', component.options)
    }
    module.hot.accept("./sendFrom.vue?vue&type=template&id=cf045a54&scoped=true", function () {
      api.rerender('cf045a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pointsMall/components/sendFrom.vue"
export default component.exports